<template>
    <div>
        设备服务费明细
    </div>
</template>

<script>
    export default {
        name: "RptDevServChgDet"
    }
</script>

<style scoped>

</style>